import { formatBytes } from './formatBytes';
import { getFileExtension } from './getFileExtension';
import { getImageDimensions } from './getImageDimensions';

export const fileHelpers = {
    getFileExtension,
    formatBytes,
    getImageDimensions,
};
